import { getVerticalDropsType } from '../../../utils/utils';
import { IChannelGeometryVerticalDropForm } from '../../components/InputForm/ChannelGeometry/IChannelGeometry';
import { IHydraulicDataSteppedWeirForm } from '../../components/InputForm/HydraulicData/IHydraulicData';
import { IStillingBasinVerticalDropForm } from '../../components/InputForm/StillingBasin/IStillingBasin';
import { IWeirGeometrySlopedWeirForm, IWeirGeometrySteppedWeirForm, IWeirGeometryVerticalDropForm, IWeirGeometryVerticalDropTable } from '../../components/InputForm/WeirGeometry/IWeirGeometry';
import { IWingsGeometryVerticalDropForm } from '../../components/InputForm/WingsGeometry/IWingsGeometry';
import { EVerticalDropsTypes } from '../../enum/general';
import { IProjectMacra2 } from '../../store/project/projectSlice';
import { ISlopedGabionParamsRequest, ISteppedGabionParamsRequest, IVerticalDropsParamsRequest, IWeirGeometryRequest } from '../IApiRequest';
import BeMaccaferriCalculationProvider from './BeMaccaferriCalculationProvider';

//CALCULATION
export const getSlopedResultsAsync = async (data: IProjectMacra2) => {
    let payload: ISlopedGabionParamsRequest = {
        mainInput: {
            designDischarge: data.hydraulicData?.discharge!,
            roughnessCoefficient: data.hydraulicData?.roughnessCoefficient!,
            riverBedGradient: data.hydraulicData?.riverBedGradient!,
            bankTopElevation: data.geometry?.bankTopElevation!,
            channelWidth: data.geometry?.channelWidth!,
            crestLenght: (data.weirGeometry as IWeirGeometrySlopedWeirForm).crestLength!,
            chuteSlope: (data.weirGeometry as IWeirGeometrySlopedWeirForm).stepRatio!,
            liningThickness: (data.weirGeometry as IWeirGeometrySlopedWeirForm).liningThickness!,
            height: (data.weirGeometry as IWeirGeometrySlopedWeirForm).height!,
            wingsWidth: data.wingsGeometry?.width!,
            wingsOffset: data.wingsGeometry?.offset!,
            wingsHeight: data.wingsGeometry?.height!,
            counterweirElevation: data.stillingBasin?.counterweirElevation!,
            poolLength: data.stillingBasin?.poolLength!,
            counterweirWidth: data.stillingBasin?.width!,
            meanDiameterOfTheFillingMaterial: data.stillingBasin?.material.physicalData![0].rockD50!,
        },
    };

    return BeMaccaferriCalculationProvider.getSlopedResultsAsync(payload);
};
export const getSteppedResultsAsync = async (data: IProjectMacra2) => {
    let payload: ISteppedGabionParamsRequest = {
        mainInput: {
            designDischarge: data.hydraulicData?.discharge!,
            roughnessCoefficient: data.hydraulicData?.roughnessCoefficient!,
            riverBedGradient: (data.hydraulicData as IHydraulicDataSteppedWeirForm).riverBedGradient,
            channelTopElevation: data.geometry?.bankTopElevation!,
            channelWidth: data.geometry?.channelWidth!,
            stepNumber: (data.weirGeometry as IWeirGeometrySteppedWeirForm).stepNumber!,
            averageSlope: (data.weirGeometry as IWeirGeometrySteppedWeirForm).stepRatio!,
            gabionWidth: (data.weirGeometry as IWeirGeometrySteppedWeirForm).gabionWidth!,
            stepHeight: (data.weirGeometry as IWeirGeometrySteppedWeirForm).stepHeight!,
            foundationLayers: (data.weirGeometry as IWeirGeometrySteppedWeirForm).foundationLayers!,
            crestWidth: data.wingsGeometry?.width!,
            crestOffset: data.wingsGeometry?.offset!,
            crestHeight: data.wingsGeometry?.height!,
            counterweirElevation: data.stillingBasin?.counterweirElevation!,
            length: data.stillingBasin?.poolLength!,
            dissipation: (data.hydraulicData as IHydraulicDataSteppedWeirForm).dissipation,
            dissipationType: (data.hydraulicData as IHydraulicDataSteppedWeirForm).dissipationType,
            counterweirWidth: data.stillingBasin?.width!,
        },
    };
    return BeMaccaferriCalculationProvider.getSteppedResultsAsync(payload);
};
export const getVerticalResultsAsync = async (data: IProjectMacra2) => {
    let layers: IWeirGeometryRequest[] = (data.weirGeometry as IWeirGeometryVerticalDropForm).layer.map(layer => ({
        weirNumber: layer.layerNumber,
        width: layer.layerWidth,
        offset: layer.layerOffset,
        height: layer.layerHeight,
    }));
    layers = layers.filter(layer => layer.weirNumber !== 1);

    let payload: IVerticalDropsParamsRequest = {
        verticalDropsType: getVerticalDropsType(data.stillingBasin!),
        soilInput: {
            unitWeight: data.soilData?.material?.physicalData![0].soilUnitWeight!,
            frictionAngle: data.soilData?.material?.physicalData![0].soilFrictionAngle!,
            laneCoefficient: data.soilData?.material?.physicalData![0].laneCoefficient!,
            gabionPorosity: data.soilData?.gabionPorosity!,
            rockFillUnitWeight: data.soilData?.rockFillUnitWeight!,
            frictionAngleSoilWeir: data.soilData?.frictionAngleSoilWeir!,
            frictionCoefficientSoilFoundation: data.soilData?.coefficientSoilFoundation!,
        },
        geometryInput: {
            numberOfLayers: (data.weirGeometry as IWeirGeometryVerticalDropForm).layer.length - 1,
            weirGeometries: layers,
            foundationDepth: (data.weirGeometry as IWeirGeometryVerticalDropForm).foundation,
        },
        mainInput: {
            designDischarge: data.hydraulicData?.discharge!,
            riverBedGradient: data.hydraulicData?.riverBedGradient!,
            roughnessCoefficient: data.hydraulicData?.roughnessCoefficient!,
            channelTopElevation: data.geometry?.bankTopElevation!,
            channelWidth: data.geometry?.channelWidth!,
            slopeOfLeftBank: (data.geometry as IChannelGeometryVerticalDropForm).slopeOfLeftBank!,
            slopeOfRightBank: (data.geometry as IChannelGeometryVerticalDropForm).slopeOfRightBank!,
            weirCrestWidth: data.wingsGeometry?.width!,
            slopeAngle: (data.wingsGeometry as IWingsGeometryVerticalDropForm).slopeAngle!,
            granularMaterialDownstream: data.soilData?.granularMaterialDownstream!,
            counterweirElevation: data.stillingBasin?.counterweirElevation!,
            counterweirWidth: data.stillingBasin?.width!,
            basinLengthDesigned: data.stillingBasin?.poolLength!,
            basinElevationDesigned: data.stillingBasin?.stillingBasinElevation!,
            basinRevetmentThickness: data.stillingBasin?.thickness!,
        },
    };
    return BeMaccaferriCalculationProvider.getVerticalResultsAsync(payload);
};
